import { Button, Modal, ModalBody } from "reactstrap";
import { categories, discountFilters } from "../../dummyData";
import CheckedInput from "../inputs/CheckedInput";
import LabeledCheckedInput from "../inputs/LabeledCheckedInput";
import { useState } from "react";
import { DiscountIcon } from "../../assets/designedPickedIcons";
import { useTranslation } from "../../languages";

const NotificationSettings = ({ isOpen, setisOpen }) => {
  const [allCategories, setAllCategories] = useState(
    categories?.map((item) => ({ ...item, isSelected: false }))
  );
  const handleCategorySelect = (item, at) => {
    let array = [...allCategories];
    array[at].isSelected = !array[at].isSelected;
    setAllCategories(array);
  };
  const [discountOptions, setDiscountOptions] = useState(
    discountFilters?.map((i) => ({ ...i, isSelected: false }))
  );
  const handleDiscountSelect = (value, index) => {
    let array = [...discountOptions];
    array[index].isSelected = value;
    setDiscountOptions(array);
  };
  const { t } = useTranslation();
  return (
    <Modal
      centered
      className="custom-modal"
      size="lg"
      isOpen={isOpen}
      toggle={() => setisOpen((prev) => !prev)}
    >
      <ModalBody className="bg-white p-4" style={{ borderRadius: "28.24px" }}>
        <h3 className="f-6  figma-shadowed-black-text m-0 text-center mb-3 ">
          {t("notifications")}
        </h3>
        <h5 className="text-center text-black f-5 mb-5">
          {t("specifyInterest")}
        </h5>
        <div className="grid-container-3 justify-content-between justify-items-between gap-3 mb-5 ">
          {allCategories?.map((item, at) => (
            <LabeledCheckedInput
              iconColor={item?.color}
              iconSize={30}
              label={t(item?.key)}
              value={item?.isSelected}
              Icon={item?.icon}
              setValue={(v) => handleCategorySelect(item, at)}
            />
          ))}
        </div>

        <h5 className="color-primary-black-3 mb-3 mt-4">{t("discount")}</h5>
        <div className="gap-3 grid-container-3">
          {discountOptions?.map((item, key) => (
            <LabeledCheckedInput
              label={
                <div
                  className="d-flex align-items-center "
                  style={{ gap: "0.3rem" }}
                >
                  <DiscountIcon
                    size={{ height: 28, width: 20 }}
                    color={item?.color}
                  />
                  {item?.title}
                </div>
              }
              iconColor={item?.color}
              value={item?.isSelected}
              iconSize={30}
              setValue={(v) => handleDiscountSelect(v, key)}
            />
          ))}
        </div>

        <div className="text-center mt-5">
          <Button
            onClick={() => {
              setisOpen(false);
            }}
            className="standard-rounded-btn   btn-md full-width"
            style={{ maxWidth: "380px" }}
          >
            {t("save")}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default NotificationSettings;
